import { logEventWithUtcTime } from '@biniyog/firebase';
import decode from 'jwt-decode';

export function logLoginEvent(access_token: string, method: string) {
  if (!access_token) return;
  try {
    const { uuid } = decode(access_token) as { uuid: string };
    logEventWithUtcTime('login', { user_id: uuid, user_uuid: uuid, method: method ?? '' });
  } catch {
    // No Action required
  }
}
